/* tslint:disable */
/* eslint-disable */
// Shared OpenAPI support generated by `npm run apis:all`. Do not edit manually.
import { mapValues } from '../runtime';
export interface ProtobufAny {
  [key: string]: object | any;
  type?: string;
}

export function instanceOfProtobufAny(value: object): value is ProtobufAny {
  return true;
}

export function ProtobufAnyFromJSON(json: any): ProtobufAny {
  return ProtobufAnyFromJSONTyped(json, false);
}

export function ProtobufAnyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProtobufAny {
  if (json == null) {
    return json;
  }
  return {
    ...json,
    type: json['@type'] == null ? undefined : json['@type'],
  };
}

export function ProtobufAnyToJSON(json: any): ProtobufAny {
  return ProtobufAnyToJSONTyped(json, false);
}

export function ProtobufAnyToJSONTyped(
  value?: ProtobufAny | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    ...value,
    '@type': value['type'],
  };
}
